import React from 'react';

import styled from 'styled-components';

import TenantConfig from '../../config';

const FooterContainer = styled.div`
  width: calc(100% - 110px);
  height: 308px;
  background: #221c2f;
  color: white;
  padding: 55px;

  @media screen and (max-width: 767px) {
    width: calc(100% - 40px);
    height: initial;
    padding: 40px 20px;
  }
`;

const FooterContent = styled.div`
  display: flex;
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;

  @media screen and (max-width: 767px) {
    flex-direction: column;
  }
`;

const FooterDescription = styled.div`
  width: 40%;
  padding-right: 100px;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 767px) {
    width: 100%;
    padding-right: 0;
    padding-bottom: 40px;
  }
`;

const FooterLogo = styled.img`
  width: 200px;
  margin-bottom: 15px;
`;

const DescriptionText = styled.span``;

const FooterMenus = styled.div`
  width: 60%;
  padding-left: 125px;
  padding-right: 25px;
  display: flex;
  justify-content: space-between;
  border-left: 1px solid white;

  @media screen and (max-width: 767px) {
    width: 100%;
    padding: 0;
    flex-direction: column;
    border-left: 0;
    border-top: 1px solid white;
    padding-top: 20px;
  }
`;

const FooterMenuList = styled.ul`
  list-style: none;

  @media screen and (max-width: 767px) {
    padding-inline-start: 0;

    li {
      padding-left: 20px;
      margin-bottom: 20px;

      &.title {
        padding-left: 0;
      }
    }
  }
`;

const FooterMenuItem = styled.li`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }

  &.title {
    font-weight: 700;
    font-size: 22px;
    line-height: 22px;
    margin-bottom: 24px;
  }

  &.socialIcons {
    display: flex;
    column-gap: 25px;

    img {
      width: 20px;
      height: 20px;
    }
  }
`;

const FooterMenuLink = styled.a`
  color: white;
  text-decoration: none;
`;

const MerchantPortalFooter = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <FooterDescription>
          <FooterLogo src={TenantConfig.footerLogo} />
          <DescriptionText>
            ©2022 B.S.D. Capital, Inc. dba Lendistry | 777 S. Alameda Street, 2nd floor, Los
            Angeles, CA 90021. All rights reserved.
          </DescriptionText>
        </FooterDescription>
        <FooterMenus>
          <FooterMenuList>
            <FooterMenuItem className="title">Company</FooterMenuItem>
            <FooterMenuItem>
              <FooterMenuLink target="_blank" href="https://lendistryinteractive.com/terms-of-use">
                Terms of Use
              </FooterMenuLink>
            </FooterMenuItem>
            <FooterMenuItem>
              <FooterMenuLink target="_blank" href="https://lendistryinteractive.com/privacypolicy">
                Privacy Policy
              </FooterMenuLink>
            </FooterMenuItem>
          </FooterMenuList>
          <FooterMenuList>
            <FooterMenuItem className="title">Support</FooterMenuItem>
            <FooterMenuItem>
              Financing:
              <br />
              1-888-216-6424
            </FooterMenuItem>
            <FooterMenuItem>
              Monday - Friday
              <br />
              9am - 8pm ET
            </FooterMenuItem>
          </FooterMenuList>
        </FooterMenus>
      </FooterContent>
    </FooterContainer>
  );
};

export default MerchantPortalFooter;
